export type ClipsPageLoadingKind = 'unknown' | 'processing' | 'clips';
export type ClipsLoadingStepId = 'resource' | 'clips' | 'scene' | 'transcription';
export type ClipsLoadingStepState = 'complete' | 'active' | 'pending';

export function resolveClipsPageLoadingKind({
  resourceLoading,
  status,
  clipsLoading,
}: {
  resourceLoading: boolean;
  status?: string | null;
  clipsLoading: boolean;
}): ClipsPageLoadingKind | null {
  if (status === 'failure' || status === 'expired') return null;
  if (status && status !== 'success') return 'processing';
  if (status === 'success' && (resourceLoading || clipsLoading)) return 'clips';
  if (resourceLoading || !status) return 'unknown';
  return null;
}

export function shouldFetchClips(status?: string | null): boolean {
  return status === 'success';
}

const STEP_IDS: ClipsLoadingStepId[] = ['resource', 'clips', 'scene', 'transcription'];

export function resolveClipsLoadingSteps({
  resourceLoaded,
  clipsLoaded,
  sceneLoaded,
  transcriptionLoaded,
}: {
  resourceLoaded: boolean;
  clipsLoaded: boolean;
  sceneLoaded: boolean;
  transcriptionLoaded: boolean;
}): Array<{ id: ClipsLoadingStepId; state: ClipsLoadingStepState }> {
  const loaded: Record<ClipsLoadingStepId, boolean> = {
    resource: resourceLoaded,
    clips: clipsLoaded,
    scene: sceneLoaded,
    transcription: transcriptionLoaded,
  };

  let activeAssigned = false;
  return STEP_IDS.map((id) => {
    if (loaded[id]) return { id, state: 'complete' as const };
    if (!activeAssigned) {
      activeAssigned = true;
      return { id, state: 'active' as const };
    }
    return { id, state: 'pending' as const };
  });
}
